"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var connected_react_router_1 = require("connected-react-router");
var history_1 = require("history");
var React = require("react");
var react_router_1 = require("react-router");
var AppContext_1 = require("./AppContext");
var Contact_1 = require("./components/Contact");
var Gallery_1 = require("./components/Gallery");
var Home_1 = require("./components/Home");
var Layout_1 = require("./components/Layout");
var Wines_1 = require("./components/Wines");
require("./styles.css");
require("react-image-gallery/styles/css/image-gallery.css");
var App = /** @class */ (function (_super) {
    __extends(App, _super);
    function App() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.baseUrl = document.getElementsByTagName('base')[0].getAttribute('href');
        _this.history = (0, history_1.createBrowserHistory)({ basename: _this.baseUrl });
        return _this;
    }
    App.prototype.render = function () {
        return (React.createElement(connected_react_router_1.ConnectedRouter, { history: this.history },
            React.createElement(AppContext_1.AppContextProvider, null,
                React.createElement(Layout_1.default, null,
                    React.createElement(react_router_1.Route, { exact: true, path: '/', component: Home_1.Home }),
                    React.createElement(react_router_1.Route, { exact: true, path: '/wina', component: Wines_1.Wines }),
                    React.createElement(react_router_1.Route, { exact: true, path: '/spacer', component: Home_1.VirtualWalk }),
                    React.createElement(react_router_1.Route, { exact: true, path: '/galeria', component: Gallery_1.Gallery }),
                    React.createElement(react_router_1.Route, { exact: true, path: '/kontakt', component: Contact_1.Contact })))));
    };
    return App;
}(React.Component));
exports.default = App;
;
//# sourceMappingURL=App.js.map